import { ApiService } from '~/shared/api'
import { restGetList, sendForm } from '~/shared/utils/decorators'
import type { QueryParams, ServiceRestGetList, ServiceCanSendForm } from '~/shared/interfaces'
import { toModels } from '~/shared/api/utils'
import { AccountCompanyModel } from '~/model/AccountCompanies'

// eslint-disable-next-line
interface AccountCompaniesService
  extends ServiceRestGetList,
    ServiceCanSendForm {}

// Интерфейсы для ответов
interface AssignUserResponse {
  phone: number // В ответе приходит как number
  success: boolean
}

interface AssignResponsiblesApiResponse {
  statusCode: number
  message: string
  data: {
    results: Array<AssignUserResponse>
  }
}

interface DetachingUserResponse {
  data: {
    success: boolean
    message?: string
  }
}

@restGetList
@sendForm
// eslint-disable-next-line no-redeclare
class AccountCompaniesService extends ApiService {
  protected route: string = 'vacancies/manager/companies'
  protected routeAssignManager: string = '/api/v1/yavagro/vacancies/manager/assign-vacancy-managers'
  protected routeDetachingUser: string = '/api/v1/yavagro/vacancies/manager/remove-vacancy-manager'

  getCompaniesList(params: QueryParams = {}): Promise<Array<AccountCompanyModel>> {
    return this.getList(params).then(toModels(AccountCompanyModel))
  }

  assignResponsiblesToCompany(params: QueryParams = {}): Promise<Array<AssignUserResponse>> {
    return this.requestService
      .request<AssignResponsiblesApiResponse>({
        url: this.routeAssignManager,
        method: 'POST',
        data: params
      })
      .then(response => {
        return response.data.data.results
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Ошибка добавления менеджера:', error)
        return []
      })
  }

  detachingUserFromCompany(phone: string, id: number): Promise<boolean> {
    return this.requestService
      .request<DetachingUserResponse>({
        url: this.routeDetachingUser,
        method: 'POST',
        data: { phone, company_id: id }
      })
      .then(response => {
        return response.data.data?.success ?? false
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Ошибка открепления пользователя:', error)
        return false
      })
  }
}

export default AccountCompaniesService
